import { defineComponent as _defineComponent } from 'vue'
import { ref, onMounted, onUnmounted } from "vue";
import { useAuth } from "../store/auth";
import router, {
	navMenuRoutes
} from "../router";
import CanineLogo from '@/resources/images/Canine-Revolution-Logo-white-1.png';
import Hamburger from "./hamburger.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'header-nav',
  setup(__props, { expose: __expose }) {
  __expose();

const auth = useAuth();

const openDropdown = ref(false);
const openNav = ref(false);

const mediaQuery = ref<MediaQueryList>(matchMedia('(max-width: 800px)'));
const isMobile = ref(mediaQuery.value.matches);
function onMobileChange(ev: MediaQueryListEvent) {
	isMobile.value = ev.matches;
}
onMounted(() => {
	mediaQuery.value.addEventListener('change', onMobileChange);
});
onUnmounted(() => {
	mediaQuery.value.removeEventListener('change', onMobileChange);
});
onUnmounted(router.afterEach(() => {
	openDropdown.value = false;
	openNav.value = false;
}));

const logout = async() =>{
	await auth.signOut();
	router.push('/auth');
};



const __returned__ = { auth, openDropdown, openNav, mediaQuery, isMobile, onMobileChange, logout, ref, onMounted, onUnmounted, get useAuth() { return useAuth }, get router() { return router }, get navMenuRoutes() { return navMenuRoutes }, get CanineLogo() { return CanineLogo }, Hamburger }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})